import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-398d5dcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "yt-user-menu" }
const _hoisted_2 = { class: "yt-user-menu__promo" }
const _hoisted_3 = { class: "yt-user-menu__promo-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "yt-user-menu__promo-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-crown" })
], -1))
const _hoisted_5 = { class: "yt-user-menu__promo-text" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "yt-user-menu__name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "yt-user-menu__points-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-coins" })
], -1))
const _hoisted_11 = { class: "yt-user-menu__points-meta" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-chevron-right yt-user-menu__points-chevron",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-gift",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-chevron-right yt-user-menu__checkin-chevron",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_15 = { class: "yt-user-menu__scroll" }
const _hoisted_16 = { class: "yt-user-menu__group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-arrows-rotate",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_18 = { class: "yt-user-menu__group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-gear",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-lock",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_21 = { class: "yt-user-menu__group yt-user-menu__group--last" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-arrow-right-from-bracket",
  "aria-hidden": "true"
}, null, -1))

import { watch } from 'vue'
import router from '@/router'
import commons from '@/utils/Common'
import {
  CUSTOMER_POST_NEWS,
  CUSTOMER_SETTING_ACCOUNT,
  DASHBOARD,
  HOME,
  LOGIN_DAILY_POINT,
  LOYALTY_POINTS,
  PASSWORD,
} from '@/const/path'
import CustomerMenu from '@/components/Headers/default/customer/api/CustomerMenu.vue'
import { useLoyaltyPoints } from '@/composables/useLoyaltyPoints'

const drawerWidth = 320

export default /*#__PURE__*/_defineComponent({
  __name: 'DrawerCustomer',
  props: /*#__PURE__*/_mergeModels({
    userTagName: { default: '' }
  }, {
    "open": { type: Boolean, ...{ default: false } },
    "openModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(["logged-out"], ["update:open"]),
  setup(__props: any, { emit: __emit }) {

const props = __props

const open = _useModel<boolean>(__props, 'open')

const emit = __emit

const { balanceFull, tierName, refresh } = useLoyaltyPoints()

watch(open, (val) => {
  if (val) refresh()
})

const close = () => {
  open.value = false
}

const goMenu = (path: string) => {
  open.value = false
  router.push({ path }).catch(() => undefined)
}

const logOut = () => {
  open.value = false
  commons.logOut()
  emit('logged-out')
  router.push({ path: HOME })
}

return (_ctx: any,_cache: any) => {
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    open: open.value,
    "onUpdate:open": _cache[6] || (_cache[6] = ($event: any) => ((open).value = $event)),
    placement: "right",
    width: drawerWidth,
    closable: false,
    title: null,
    "root-class-name": "yt-user-drawer-root",
    class: "yt-user-drawer",
    "body-style": { padding: 0, height: '100%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('header.vipVoucherTitle')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.vipVoucherDesc')), 1)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "yt-user-menu__promo-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goMenu(_unref(DASHBOARD))))
          }, _toDisplayString(_ctx.$t('header.buyNow')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "yt-user-menu__close",
            "aria-label": _ctx.$t('header.close'),
            onClick: close
          }, _hoisted_8, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.userTagName), 1),
        _createElementVNode("button", {
          type: "button",
          class: "yt-user-menu__points",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goMenu(_unref(LOYALTY_POINTS))))
        }, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, [
            _createElementVNode("strong", null, _toDisplayString(_unref(balanceFull)) + " " + _toDisplayString(_ctx.$t('points.unit')), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.pointsTier', { tier: _unref(tierName) })), 1)
          ]),
          _hoisted_12
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "yt-user-menu__checkin",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goMenu(_unref(LOGIN_DAILY_POINT))))
        }, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.checkInClaim')), 1),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              type: "button",
              class: "yt-user-menu__item",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (goMenu(_unref(CUSTOMER_POST_NEWS))))
            }, [
              _hoisted_17,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.switchToPost')), 1)
            ])
          ]),
          _createVNode(CustomerMenu, {
            onNavigate: goMenu,
            onLogout: logOut
          }),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              type: "button",
              class: "yt-user-menu__item",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (goMenu(_unref(CUSTOMER_SETTING_ACCOUNT))))
            }, [
              _hoisted_19,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.accountSettings')), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "yt-user-menu__item",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (goMenu(_unref(PASSWORD))))
            }, [
              _hoisted_20,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.changePassword')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              type: "button",
              class: "yt-user-menu__item",
              onClick: logOut
            }, [
              _hoisted_22,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('text.logOut')), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})